import React from 'react';
import { RelatedBlock } from '@wix/da-papi-types';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import OriginalsShopCard from '../../../../ShopCard/OriginalsShopCard';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';

import s from './OriginalSource.scss';

interface Props {
  block: RelatedBlock;
  className?: string;
}

const OriginalSource: React.FC<Props> = ({
  block,
  className,
}) => {
  const custom_exclusives = useFlag('custom_exclusives');
  const { deviations } = block;

  const { ref, dimensions: measuredContainer } = useMeasureElementCookie(
    MeasuredCookieType.DEVIATION_SIDEBAR,
    {
      cookieDim: 'width',
    }
  );

  if (!custom_exclusives || !deviations || deviations.length === 0) {
    return null;
  }
  const deviation = deviations[0];

  return (
    <SidebarBlockWrapper
      deviation={deviation}
      block={block}
      className={className}
    >
      <div ref={ref} className={s['root']}>
        <OriginalsShopCard
          key={deviation.deviationId}
          deviation={deviation}
          width={measuredContainer.width}
          withAuthorDetails
        />
      </div>
    </SidebarBlockWrapper>
  );
};
OriginalSource.displayName = 'OriginalSource';

export default OriginalSource;
